import { render, staticRenderFns } from "./CheckboxGridFormPart.vue?vue&type=template&id=6234831a&scoped=true"
import script from "./CheckboxGridFormPart.vue?vue&type=script&lang=js"
export * from "./CheckboxGridFormPart.vue?vue&type=script&lang=js"
import style0 from "./CheckboxGridFormPart.vue?vue&type=style&index=0&id=6234831a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234831a",
  null
  
)

export default component.exports